import axios from "axios"

export default {
    namespaced: true,
    state: {
        deals: [],
        filters: localStorage.getItem('statFilters') ? JSON.parse(localStorage.getItem('statFilters')) : {
            date: [],
            agents: [],
            sources: [],
            types: []
        }
    },
    mutations: {
        SET_DEALS(state, deals) {
            state.deals = deals;
        },
        SET_DATE_FILTER(state, date) {
            state.filters.date = date;
            localStorage.setItem('statFilters', JSON.stringify(state.filters));
        },
        SET_TYPE_FILTER(state, types) {
            state.filters.types = [];

            types.forEach(t => {
                state.filters.types.push(t);
            });

            localStorage.setItem('statFilters', JSON.stringify(state.filters));
        },
        SET_SOURCE_FILTER(state, sources) {
            state.filters.sources = [];

            sources.forEach(s => {
                state.filters.sources.push(s);
            });

            localStorage.setItem('statFilters', JSON.stringify(state.filters));
        },
        SET_AGENT_FILTER(state, agents) {
            state.filters.agents = agents;
            localStorage.setItem('statFilters', JSON.stringify(state.filters));
        },
    },
    getters: {
        deals: state => state.deals,
        filters: state => state.filters
    },
    actions: {
        loadDeals({ commit, state }) {
            axios.post("/statistic/deals", { filters: state.filters})
            .then((res) => {
                commit("SET_DEALS", res.data.deals)
            })
                .catch(err => console.log(err));
        }
    },
}

